// biome-ignore lint/style/noRestrictedImports: component usage
import type { CheckedState } from "@radix-ui/react-checkbox";

// biome-ignore lint/style/noRestrictedImports: re-export
export type { CheckedState } from "@radix-ui/react-checkbox";

/**
 * Determines the checked state (`true`, `false`, or `"indeterminate"`) from an iterable of boolean values.
 *
 * @param values - An iterable collection of boolean values representing the checked state of items.
 * @param emptyFallback - The value to return if the iterable is empty. Defaults to `false`.
 * @returns `true` if all values are `true`, `false` if all values are `false`, or `"indeterminate"` if values are mixed.
 */
export function toCheckState(values: Iterable<boolean>, emptyFallback: CheckedState = false): CheckedState {
	let checkedState: undefined | CheckedState;

	for (const value of values) {
		if (checkedState == null) {
			checkedState = value;
		} else if (checkedState !== value) {
			return "indeterminate";
		}
	}

	// the value is undefined when the iterable is empty
	return checkedState ?? emptyFallback;
}
